export const DAMAGE_REPORT_OPTIONS_SELECTED = 'DAMAGE_REPORT_OPTIONS_SELECTED';
export const STEP_INFO_ABOUT_DAMAGE_FULFILLED = 'STEP_INFO_ABOUT_DAMAGE_FULFILLED';
export const STEP_INFO_FULFILLED = 'STEP_INFO_FULFILLED';
export const STEP_PAYMENT_INFO_FULFILLED = 'STEP_PAYMENT_INFO_FULFILLED';
export const SUBMIT_REPORT_PENDING = 'SUBMIT_REPORT_PENDING';
export const SUBMIT_REPORT_FULFILLED = 'SUBMIT_REPORT_FULFILLED';
export const SUBMIT_REPORT_FAILED = 'SUBMIT_REPORT_FAILED';
